import moment from "moment";

const validate = (validators, setErrors) => {
  const e2 = {};
  validators.forEach(v => {
    e2[v.fieldName] = !v.isValid(v.fieldValue);
  });
  const isInvalid = Object.keys(e2).reduce((accum, key) => accum || e2[key], false);
  setErrors(errors => ({ ...errors, ...e2 }));
  return !isInvalid;
}

const isSelected = (item) => {
  return item !== null && typeof item !== 'undefined';
};

const isSelecionComplete = (items) => {
  return items !== null && typeof items !== 'undefined' && items.length > 0;
};

const isCompleted = val => val && val.length >= 2;
const isNumeric = val => {
  if (val === null || val === '') return true;
  const reg = /^0*[1-9][0-9]*$/i;
  return !(!reg.test(String(val).toLowerCase()));

}

const isDateValid = ({ day, month, year, date }) => {
  return !(!day || isNaN(day) ||
    !month || isNaN(month) ||
    !year || isNaN(year) ||
    year < 1900 ||
    !moment(`${year}-${month}-${day}`).isValid());
}

const isAFutureDate = (day, month, year) => {
  if (year < 1900)
    return false;
  if (moment(`${year}-${month}-${day}`).isAfter(moment())) {
    return true;
  }

  return false;
}

const isAustralianPhoneNumberOrNull = number => {
  if (!number)
    return true;
  const re = /^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/i;
  return !(number === null || !re.test(String(number).toLowerCase()));
}

const isDayTimeNumberOrNull = number => {
  debugger;
  if (!number)
    return true;
  const re = /^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})|1[38]00\s?(\d{2}\s?\d{2}\s?\d{2}|\d{3}\s?\d{3})$/i;
  return !(number === null || !re.test(String(number).toLowerCase()));
}

const isValidWebAddress = webaddress => {
  if (!webaddress)
    return true;
  const re = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/i;
  return !(!re.test(String(webaddress).toLowerCase()));
}

const isAustralianPhoneNumber = number => {
  const re = /^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/i;
  return !(number === null || !re.test(String(number).toLowerCase()));
}

const isFileUploaded = val => {
  return val && Array.isArray(val) && val.filter(v => v.status === 'done').length;
}

const isDateValidAndPast = ({ day, month, year, date }) => {
  return !(!day || isNaN(day) ||
    !month || isNaN(month) ||
    !year || isNaN(year) ||
    year < 1900 ||
    !moment(`${year}-${month}-${day}`).isValid() ||
    moment(`${year}-${month}-${day}`).isAfter(moment()));
}

const isDateValidAnd18Yo = ({ day, month, year, date }) => {
  return !(!day || isNaN(day) ||
    !month || isNaN(month) ||
    !year || isNaN(year) ||
    year < 1900 ||
    !moment(`${year}-${month}-${day}`).isValid() ||
    !(moment().diff(`${year}-${month}-${day}`, 'years',true)>=18) ||
    moment(`${year}-${month}-${day}`).isAfter(moment()));
}

const hasAnyValue = array => {
  return array && array.length > 0;
}

const objExistInArray = (array, object) =>{
  let matched = true;
  for(var i = 0; i < array.length; i++){
    if (JSON.stringify(array[i]) === JSON.stringify(object)) {
      matched = true;
      break;
    }
    else{
      matched = false;
    }
  }
   
  return !matched;
  // map = array.map((arr, i) => {    
  //   if (JSON.stringify(arr) === JSON.stringify(obj)) {
  //     break;
  //   }
  //   else{
  //     return false;
  //   }
  // })
  // // accumulates  all the booleans into one.
  // const ret = map.reduce((acc, el) => acc = acc && el, true); 
}

const isValidEmail = email => {
  const re = /^[0-9a-zA-Z]([-.'\w]*[0-9a-zA-Z])*[-.\w]*@(([0-9a-zA-Z][-\w]*[0-9a-zA-Z]\.)+[a-zA-Z]{2,9})$/i;
  return !(email === null || !re.test(String(email).toLowerCase()));
}

const isAddressValid = address => {
  if (!address) {
    return false;
  } else {
    if (address.customType) {
      const a = address.value.details;
      return a && a.addressLine1 && a.addressLine1.length > 2 &&
        a.suburb && a.suburb.length > 2 &&
        a.state && a.state.value !== null &&
        a.postcode && a.postcode.length > 2 &&
        (!address.international || (address.international && a.country && a.country.length > 2));
    } else {
      return true;
    }
  }
}

const clearError = (errName, errors, setErrors) => {
  const e2 = { ...errors };
  e2[errName] = false;
  setErrors(e2);
}

const clearErrors = (errors, setErrors) => {
  const e2 = { ...errors };
  Object
    .keys(e2)
    .forEach(errName => e2[errName] = false);
  setErrors(e2);
}

const scrollToError = (errorSequences, errors) => {

  window.setTimeout(() => {
    const errorElements = document.querySelectorAll("[class*=ErrorMsg_error]");
    if (errorElements && errorElements.length > 0) {
      const yOffset = -150;
      const y = errorElements[0].getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }, 100);

  let flagRefSet = false;
  /*
    errorSequences.map((obj)=>{
      if(flagRefSet==false && errors[obj.errorKey]==true){
        obj.refError.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
        obj.refError.current.focus();
        flagRefSet = true;
      }
    });
    */
}

export {
  clearError,
  clearErrors,
  isSelected,
  isCompleted,
  isDateValid,
  isDateValidAndPast,
  isDateValidAnd18Yo,
  isAFutureDate,
  hasAnyValue,
  isNumeric,
  isValidEmail,
  isAddressValid,
  isSelecionComplete,
  validate,
  isFileUploaded,
  isAustralianPhoneNumber,
  isAustralianPhoneNumberOrNull,
  isDayTimeNumberOrNull,
  scrollToError,
  isValidWebAddress,
  objExistInArray
};
